module.exports = __webpack_public_path__ + "static/media/kingmaker.0b90d20f.webp";